module.exports = __webpack_public_path__ + "static/media/unlimited-x_promo-card.e1f8f48c.png";